/**
 * Formats a task name by capitalizing each word and replacing underscores with spaces
 * @param {string} name - The task name to format
 * @returns {string} - The formatted name
 */
export const formatTaskName = (name) => {
  return name.split('_').map(word => 
    word.charAt(0) + word.slice(1).toLowerCase()
  ).join(' ');
};

/**
 * Creates a compact model name for mobile displays
 * @param {string} fullName - The full model name
 * @returns {string} - The shortened model name
 */
export const getCompactName = (fullName) => {
  if (fullName.startsWith("LLAMA")) {
    const version = fullName.split(' ')[1];
    return `L${version}`;
  } else if (fullName.startsWith("GPT")) {
    return fullName.split(' ').slice(0, 2).join(' ');
  } else {
    return fullName.split(' ')[0];
  }
};
